import React from "react";

import { duration } from "@formant/core/model/duration";

import { Select } from "../../common/Select";

export interface ISpanSelectorProps {
    value: number;
    onChange: (value: number) => void;
}

const options = [
    { label: "24 hrs", value: 24 * duration.hour },
    { label: "20 hrs", value: 20 * duration.hour },
    { label: "18 hrs", value: 18 * duration.hour },
    { label: "12 hrs", value: 12 * duration.hour },
    { label: "10 hrs", value: 10 * duration.hour },
    { label: "9 hrs", value: 9 * duration.hour },
    { label: "6 hrs", value: 6 * duration.hour },
    { label: "4 hrs", value: 4 * duration.hour },
    { label: "3 hrs", value: 3 * duration.hour },
    { label: "2 hrs", value: 2 * duration.hour },
    { label: "1 hr", value: duration.hour },
    { label: "30 min", value: 30 * duration.minute },
    { label: "10 min", value: 10 * duration.minute },
    { label: "5 min", value: 5 * duration.minute },
    { label: "1 min", value: duration.minute },
    { label: "30 sec", value: 30 * duration.second },
    { label: "5 sec", value: 5 * duration.second },
];

const label = (_: number) =>
    options.find(option => option.value === _)?.label || "";

const selectOptions = options.map(_ => _.value);

export function SpanSelector(props: ISpanSelectorProps) {
    const { value, onChange } = props;

    return (
        <Select
            value={value}
            options={selectOptions}
            label={label}
            simple={true}
            right={true}
            onChange={onChange}
        />
    );
}
